import { Paper, Skeleton, Stack, Typography } from '@mui/material'
import { OperatorActivityDto } from '../../../interfaces/IDashboard'
import InfoTooltip from './InfoTooltip'

interface OperatorActivityCardProps {
  operators: OperatorActivityDto[]
  loaded: boolean
  info?: string
}

const CARD_MIN_HEIGHT = 168
const MAX_ROWS = 5

function OperatorRow({ entry }: { entry: OperatorActivityDto }) {
  return (
    <Stack
      direction="row"
      spacing={1.5}
      sx={{
        alignItems: 'center',
        borderRadius: 1,
        py: 0.75,
        px: 1,
      }}
    >
      <Stack sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {entry.name}
        </Typography>
      </Stack>
      <Typography variant="body2" sx={{ fontWeight: 600, whiteSpace: 'nowrap' }}>
        {entry.changeCount}
      </Typography>
    </Stack>
  )
}

function OperatorActivityCard({ operators, loaded, info }: OperatorActivityCardProps) {
  let body
  if (!loaded) {
    body = (
      <Stack spacing={1}>
        <Skeleton variant="text" width="80%" />
        <Skeleton variant="text" width="70%" />
        <Skeleton variant="text" width="75%" />
      </Stack>
    )
  } else if (operators.length === 0) {
    body = (
      <Typography variant="body2" color="text.secondary">
        Ingen operatør-endringer siste 24 timer.
      </Typography>
    )
  } else {
    const rows = operators.slice(0, MAX_ROWS)
    body = (
      <Stack spacing={0.25}>
        {rows.map((entry) => (
          <OperatorRow key={entry.id} entry={entry} />
        ))}
      </Stack>
    )
  }

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        height: '100%',
        minHeight: CARD_MIN_HEIGHT,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center', mb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Operatør-aktivitet siste 24t
        </Typography>
        {info && <InfoTooltip text={info} />}
      </Stack>
      {body}
    </Paper>
  )
}

export default OperatorActivityCard
